/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivateRewardRequest } from '../../models/activate-reward-request';
import { UserRewardDto } from '../../models/user-reward-dto';

export interface PostActivateReward$Params {
  body?: ActivateRewardRequest;
}

export function postActivateReward(
  http: HttpClient,
  rootUrl: string,
  params?: PostActivateReward$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<UserRewardDto>> {
  const rb = new RequestBuilder(rootUrl, postActivateReward.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserRewardDto>;
    }),
  );
}

postActivateReward.PATH = '/Loyalty/activate-reward';
